module.exports = __webpack_public_path__ + "img/xian_wall.1f6fcf07.jpg";